export const companyInfo = {
  name: "(주)한국문화체육진흥원",
  enName: "Korea Culture & Sports Promotion Institute Co., Ltd",
  slogan: "교육을 키우며, 문화를 연결하고, 미래를 함께합니다",
  vision: "Connecting People, Culture & Future",
  founded: "2026년 1월 14일",
  ceos: "유진 · 장현이",
  address: "대전광역시 대덕구 한남로65 한남캠퍼스타운 B동 1층",
  phone: "042-639-6660",
  mobile: "010-2467-6040",
  email: "daeun6040@naver.com",
  mobile2: "010-7286-7997",
  regNumber: "717-81-04156",
  taxId: "160111-0073765",
};

export const businessAreas = [
  {
    id: 1,
    title: "외국인 유학생 유치 및 정착지원",
    description:
      "해외 학생 모집부터 대학 연계 입학 지원, 비자·서류 지원, 생활 정착 프로그램까지 외국인 유학생의 한국 정착 전 과정을 지원합니다.",
    icon: "ri-graduation-cap-line",
    items: [
      "해외 학생 모집",
      "대학 연계 입학지원",
      "비자·서류지원",
      "생활 정착 프로그램",
    ],
  },
  {
    id: 2,
    title: "국제 취업 연계",
    description:
      "외국인 인재와 국내 기업을 연결하는 매칭 서비스와 인턴십 지원, 취업 교육 및 컨설팅을 통해 국제 취업의 다리 역할을 합니다.",
    icon: "ri-briefcase-line",
    items: [
      "외국인 인재 매칭",
      "기업 인턴십 지원",
      "취업 교육 및 컨설팅",
      "JOB MATCHING",
    ],
  },
  {
    id: 3,
    title: "문화행사·축제 기획·운영",
    description:
      "지역축제, 글로벌 행사, 공연·이벤트, 문화교류 프로그램을 기획하고 운영하여 한국 문화의 가치를 국내외에 전파합니다.",
    icon: "ri-calendar-event-line",
    items: [
      "지역축제 기획",
      "글로벌 행사 운영",
      "공연·이벤트",
      "문화교류 프로그램",
    ],
  },
  {
    id: 4,
    title: "교육 프로그램 운영",
    description:
      "한국어 교육, K-Beauty 뷰티 교육, 직무·전문 교육, 다문화 교육 등 다양한 교육 프로그램을 통해 글로벌 인재 양성에 기여합니다.",
    icon: "ri-book-open-line",
    items: [
      "한국어 교육",
      "K-Beauty 교육",
      "직무·전문 교육",
      "다문화 교육",
    ],
  },
  {
    id: 5,
    title: "스포츠·체험 프로그램",
    description:
      "국제 스포츠 교류, 체육 행사, 청소년 스포츠 지원을 통해 건강한 국제 교류와 체육 문화 발전을 도모합니다.",
    icon: "ri-medal-line",
    items: [
      "국제 스포츠 교류",
      "체육 행사 운영",
      "청소년 스포츠 지원",
      "MEDIA 사업",
    ],
  },
];

export const competitiveAdvantages = [
  {
    title: "글로벌 네트워크",
    description:
      "베트남 등 해외 교육기관·기업과의 강력한 파트너십을 통해 안정적인 국제 교류 인프라를 구축했습니다.",
    icon: "ri-global-line",
  },
  {
    title: "ONE-STOP 지원시스템",
    description:
      "입학부터 정착·취업까지 전 과정을 통합 지원하는 ONE-STOP 시스템으로 유학생과 기업 모두의 부담을 최소화합니다.",
    icon: "ri-stack-line",
  },
  {
    title: "전문 인력 보유",
    description:
      "다년간의 국제 교류 경험을 보유한 전문 인력들이 각 단계별 맞춤형 서비스를 제공합니다.",
    icon: "ri-user-star-line",
  },
  {
    title: "맞춤형 프로그램",
    description:
      "학생 개인의 상황과 목표에 맞춘 개별 맞춤형 프로그램을 설계하여 최적의 결과를 도출합니다.",
    icon: "ri-settings-3-line",
  },
  {
    title: "지속 가능한 성장",
    description:
      "장기적인 비전 아래 교육·문화·체육 분야에서 지속 가능한 성장을 추구합니다.",
    icon: "ri-seedling-line",
  },
];

export const vietnamCenters = [
  {
    name: "하노이 교육센터",
    capacity: "350명",
    location: "베트남 하노이",
    partners: ["Hanoi University of Industry and Trade (HUIT)"],
  },
  {
    name: "호치민 교육센터",
    capacity: "300명",
    location: "베트남 호치민",
    partners: ["Hanoi Medical College (HMC)"],
  },
  {
    name: "다낭 교육센터",
    capacity: "250명",
    location: "베트남 다낭",
    partners: ["Hanoi College of High Technology (HTC)"],
  },
];

export const beautyPartners = [
  {
    name: "Hanoi University of Industry and Trade",
    shortName: "HUIT",
    desc: "공업·상업 분야 종합 교육기관",
  },
  {
    name: "Hanoi Medical College",
    shortName: "HMC",
    desc: "의학·보건 분야 전문 교육기관",
  },
  {
    name: "Hanoi College of High Technology",
    shortName: "HTC",
    desc: "첨단 기술·직무 교육 전문기관",
  },
];

export const futureVision = [
  {
    year: "2026",
    title: "글로벌 유학생 유치 시작",
    description:
      "연간 150명 유학생 유치 목표. 베트남, 필리핀, 몽골 등 해외 학생들의 한국 대학 입학 지원 본격화.",
  },
  {
    year: "2027",
    title: "산학협력 인재양성 체계 구축",
    description:
      "기업과 연계한 실무 중심 인재양성 프로그램 구축. 인턴십 및 취업 매칭 시스템 고도화.",
  },
  {
    year: "2028",
    title: "해외 현지지사 설립",
    description:
      "베트남·필리핀·몽골에 현지지사 설립으로 현지 학생 모집 및 지원 체계 현지화.",
  },
  {
    year: "2029",
    title: "글로벌 통합 플랫폼 완성",
    description:
      "교육·문화·취업 통합 플랫폼 완성. 동남아 대표 국제교류 전문기관으로 도약.",
  },
];

export const transportInfo = {
  bus: "한남대학교 / 한남오거리 정류장 하차 후 도보 이동",
  car: "경부고속도로 대전IC / 신탄진IC 접근 용이. 대전 중심권 15~20분 이내",
};